import { CreditDebitReconciliation } from "./credit-debit-reconciliation";

export function DebitReconciliation() {
  return <CreditDebitReconciliation transactionIndicator="DEBIT" />;
}
